import { render, staticRenderFns } from "./exportPopup.vue?vue&type=template&id=1f885f06&scoped=true&"
import script from "./exportPopup.ts?vue&type=script&lang=js&"
export * from "./exportPopup.ts?vue&type=script&lang=js&"
import style0 from "./exportPopup.less?vue&type=style&index=0&id=1f885f06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f885f06",
  null
  
)

export default component.exports